import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import M from 'materialize-css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    const closeSidenav = () => {
      const sidenav = document.querySelector('.sidenav');
      const instance = M.Sidenav.getInstance(sidenav); 
      if (instance && instance.isOpen) {
        instance.close(); 
      }
    };

    const links = document.querySelectorAll('.sidenav a');
    links.forEach(link => link.addEventListener('click', closeSidenav));

    return () => {
      links.forEach(link => link.removeEventListener('click', closeSidenav));
    };
  }, [pathname]); 

  return null;
}

export default ScrollToTop;
